module.exports = __webpack_public_path__ + "img/esgcarbonreduction.1051f9a6.png";